// Utilities
import { createSimpleFunctional } from "../../util/index.js";
export const VBannerText = createSimpleFunctional('v-banner-text');
//# sourceMappingURL=VBannerText.js.map